import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between px-2 fill-height" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePager = _resolveComponent("DatePager")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_VueLoading = _resolveComponent("VueLoading")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        app: "",
        flat: "",
        color: "white",
        height: "60px",
        class: "pt-2 mb-6",
        "extension-height": _ctx.form.status ? '30px' : '0px',
        style: {"position":"sticky","top":"0","z-index":"1000"}
      }, {
        extension: _withCtx(() => [
          _createVNode(_component_v_container, {
            fluid: "",
            class: "pa-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", null, [
                  (_ctx.form.status === 'draft')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        dense: "",
                        small: "",
                        outlined: "",
                        color: "gray",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode(" 下書き ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.form.status === 'applied')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 1,
                        dense: "",
                        small: "",
                        outlined: "",
                        color: "secondary",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode(" 申請済み ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.form.status === 'approved')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 2,
                        dense: "",
                        small: "",
                        outlined: "",
                        color: "primary",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode(" 承認済み ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  (_ctx.form.status === 'approved' && _ctx.approverRole === 'chief')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        dense: "",
                        small: "",
                        color: "primary",
                        class: "mb-4",
                        "text-color": "white"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            left: "",
                            small: ""
                          }, {
                            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                              _createTextVNode("mdi-check-circle", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[16] || (_cache[16] = _createTextVNode(" 主任 ", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  (_ctx.form.status === 'approved' && _ctx.approverRole === 'director')
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        dense: "",
                        small: "",
                        color: "primary",
                        class: "mb-4",
                        "text-color": "white"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            left: "",
                            small: ""
                          }, {
                            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                              _createTextVNode("mdi-check-circle", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[18] || (_cache[18] = _createTextVNode(" 施設長 ", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            style: {"width":"100%"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openDateDialog && _ctx.openDateDialog(...args)))
          }, [
            _createVNode(_component_DatePager, {
              date: _ctx.date,
              onAddDay: _ctx.addDay,
              onSubtractDay: _ctx.subtractDay
            }, null, 8, ["date", "onAddDay", "onSubtractDay"])
          ])
        ]),
        _: 1
      }, 8, ["extension-height"]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_VueLoading, { height: '50vh' })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_main, { class: "pa-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_container, {
                  fluid: "",
                  class: "py-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.form.activity,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.activity) = $event)),
                      label: "活動内容",
                      variant: "outlined",
                      "auto-grow": "",
                      class: "mb-2"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.form.message,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.message) = $event)),
                      label: "引き継ぎ・伝達事項",
                      variant: "outlined",
                      "auto-grow": "",
                      class: "mb-2"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.form.remarks,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.remarks) = $event)),
                      label: "備考",
                      variant: "outlined",
                      "auto-grow": "",
                      class: "mb-2"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.form.staff,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.staff) = $event)),
                      items: _ctx.staffList,
                      "item-title": "text",
                      "item-value": "value",
                      label: "担当者",
                      variant: "outlined",
                      multiple: "",
                      chips: ""
                    }, null, 8, ["modelValue", "items"]),
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.form.appliedBy,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.appliedBy) = $event)),
                      items: _ctx.staffList,
                      "item-title": "text",
                      "item-value": "value",
                      label: "申請者",
                      variant: "outlined",
                      disabled: _ctx.form.status === "draft" || _ctx.form.status === "applied" || _ctx.form.status === "approved"
                    }, null, 8, ["modelValue", "items", "disabled"]),
                    (!!_ctx.form.approvedBy)
                      ? (_openBlock(), _createBlock(_component_v_select, {
                          key: 0,
                          modelValue: _ctx.form.approvedBy,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.approvedBy) = $event)),
                          items: _ctx.staffList,
                          "item-title": "text",
                          "item-value": "value",
                          label: "承認者",
                          variant: "outlined",
                          disabled: !!_ctx.form.approvedBy
                        }, null, 8, ["modelValue", "items", "disabled"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        (!_ctx.form.status || _ctx.form.status === "draft")
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 0,
                              cols: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  block: "",
                                  variant: "outlined",
                                  onClick: _ctx.saveDraft
                                }, {
                                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                    _createTextVNode("下書きして保存", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.form.status || _ctx.form.status === "draft")
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 1,
                              cols: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  block: "",
                                  color: "primary",
                                  variant: "flat",
                                  onClick: _ctx.saveAndApply
                                }, {
                                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                    _createTextVNode("保存して申請", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.form.status === "applied")
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 2,
                              cols: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  block: "",
                                  variant: "outlined",
                                  color: "error",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeApprovalStatus('rejected')))
                                }, {
                                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                    _createTextVNode("差戻し", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.form.status === "applied")
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 3,
                              cols: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  block: "",
                                  color: "primary",
                                  variant: "flat",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeApprovalStatus('approved')))
                                }, {
                                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                    _createTextVNode("承認", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.form.status === "approved")
                          ? (_openBlock(), _createBlock(_component_v_col, {
                              key: 4,
                              cols: "6"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  block: "",
                                  color: "error",
                                  variant: "flat",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeApprovalStatus('rejected')))
                                }, {
                                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                    _createTextVNode("承認取消（差戻し）", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.dateDialogFlg,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dateDialogFlg) = $event)),
        width: "auto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_date_picker, {
            modelValue: _ctx.selectedDate,
            "onUpdate:modelValue": [
              _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedDate) = $event)),
              _ctx.dateSelected
            ],
            type: "date",
            "day-format": (date) => new Date(date).getDate(),
            "no-title": "",
            "hide-header": "",
            color: "primary",
            style: {"transform":"scale(0.8)"}
          }, null, 8, ["modelValue", "day-format", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}